import { Observable } from 'rxjs';
import { DadosPessoa } from './../shared/model/dados-pessoa';
import { McticHttpClient } from '@mctic/ng-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PessoaService {

  private readonly service = '/sepin-backend/rest/proxy/pessoa';

  constructor(private readonly mcticHttp: McticHttpClient) { }

  obterPessoaAutenticado(login: string): Observable<DadosPessoa>{
    return this.mcticHttp.get<DadosPessoa>(`${this.service}/login/${login}`);
  }


}
